import React, { useState } from 'react';
import { useTranslate, usePermissions } from 'react-admin';
import { Drawer, CreateButton } from '~/components';
import { CreateForm } from '~/components/ra';
import ApplicationRuleForm from './ApplicationRuleForm';

const ApplicationRuleCreate = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.applicationRules.fields.${key}`);
  const { permissions } = usePermissions();
  if (!permissions?.includes('externalApplication.create')) return null;
  return (
    <>
      <CreateButton onClick={handleOpen} variant='add' label={t('create')} />
      <Drawer heading={t('addNewApplicationRule')} open={open} onClose={handleClose}>
        <CreateForm resource='applicationRules' closeParent={handleClose}>
          <ApplicationRuleForm />
        </CreateForm>
      </Drawer>
    </>
  );
};

export default ApplicationRuleCreate;
